<script>
  import {External, M} from "../../../external";
  import { onMount } from 'svelte';
  import { calcPercent } from '../../../Common/tools';

  export let circleDetails = {}, entityStats = {}, salesStats = {}, entity = {};

  let completionRate = 0;

  onMount(() => {
    if (entity?.id) { // only for a single circle or a group
      let completed = entityStats?.completed || 0;
      let members = circleDetails.circle.members || 0;
      completionRate = calcPercent(completed, members);
    }
  });
</script>

<div class="flex col20 f-left store-section-analytics-warapper double-row-analytics flex-col-mobile" style="margin-top: 0px; background: #f5f6fa;">
  <div class="analytics-box analytics-box-small col5">
    <h3 class="flex align-center">{M.NEW_ENROLLED_MEMBERS}
      <span class="chart-color ml-10" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>
    </h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{entityStats?.enrolled || 0}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3 class="flex align-center">
      {M.NEW_ORDERS}
    </h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{salesStats?.orders || 0}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3 class="flex align-center">
      {M.REVENUE}
      <span class="chart-color ml-10" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>
    </h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{External.Tools.currencyToStrWithSymbol(salesStats?.sales)}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small col5">
    <h3 class="flex align-center">{M.COMPLETED}
      <span class="chart-color ml-10" style="background: #ff822f none repeat scroll 0% 0%;"></span>
    </h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>{entityStats?.completed || 0}</b>
      {#if entity?.id}
        <span>{completionRate}</span>
      {/if}
    </h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3 class="flex align-center">
      {M.ARPU}
      <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">info
				<span class="none-soft hidden-info">
					<h4>{M.AVERAGE_REVENUE_PER_USER}</h4>
					<span>{M.AVERAGE_REVENUE_PER_USER_DESC}</span>
				</span>
			</span>
    </h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{External.Tools.currencyToStrWithSymbol(salesStats?.sales / salesStats?.customers)}</b></h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3 class="flex align-center">
      {M.PAYING_MEMBERS}
    </h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{salesStats?.customers || 0}</b></h2>
  </div>
</div>
